import { render, staticRenderFns } from "./MoveTable.vue?vue&type=template&id=13dcf25f&scoped=true&"
import script from "./MoveTable.vue?vue&type=script&lang=js&"
export * from "./MoveTable.vue?vue&type=script&lang=js&"
import style0 from "./MoveTable.vue?vue&type=style&index=0&id=13dcf25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcf25f",
  null
  
)

/* custom blocks */
import block0 from "./MoveTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports